import { gql } from '@apollo/client';

export const ADJUSTMENT_FIELDS = gql`
  fragment AdjustmentFields on Adjustment {
    id
    tenantId
    orderId
    lineType
    description
    isDebitCredit
    lineMapping {
      cd {
        lineNumber
        addendumLineNumber
      }
      alta {
        lineNumber
        addendumLineNumber
      }
      hud2010 {
        lineNumber
        addendumLineNumber
      }
      hud1986 {
        lineNumber
        addendumLineNumber
      }
    }
    sectionMapping {
      cd
      alta
      hud2010
      hud1986
    }
    dcLineMapping {
      cd {
        lineNumber
        addendumLineNumber
      }
      alta {
        lineNumber
        addendumLineNumber
      }
      hud2010 {
        lineNumber
        addendumLineNumber
      }
      hud1986 {
        lineNumber
        addendumLineNumber
      }
    }
    dcSectionMapping {
      cd
      alta
      hud2010
      hud1986
    }
    defaultLineMapping {
      cdAlta
      hud2010
      hud1986
    }
    payeePayorId
    amount
    externalItemId
    createdTimestamp
    updatedTimestamp
    createdBy
    updatedBy
  }
`;

export const GET_ADJUSTMENTS_QUERY = gql`
  ${ADJUSTMENT_FIELDS}
  query GetDcAdjustments($orderId: String!, $statementType: String!, $statementSections: [String!]) {
    getDcAdjustments(orderId: $orderId, statementType: $statementType, statementSections: $statementSections) {
      adjustments {
        ...AdjustmentFields
      }
    }
  }
`;

export const GET_ADJUSTMENTS_TOTALS = gql`
  query GetAdjustmentStatementSectionTotals(
    $orderId: String!
    $statementType: String!
    $statementSections: [String!]!
  ) {
    getAdjustmentStatementSectionTotals(
      orderId: $orderId
      statementType: $statementType
      statementSections: $statementSections
    ) {
      ... on SectionSummariesTotalsWithSeller {
        totalDueFromBorrower
        totalPaidByBorrower
        totalDueToSeller
        totalDueFromSeller
        borrowerCalcTotal
        sellerCalcTotal
      }
      ... on SectionSummariesTotalsWithoutSeller {
        totalDueFromBorrower
        totalPaidByBorrower
        borrowerCalcTotal
      }
      ... on AltaSectionSummaryTotals {
        debitBorrower
        creditBorrower
        debitSeller
        creditSeller
        toFromBorrower
        toFromSeller
        totalBorrowerDebit
        totalBorrowerCredit
        totalSellerDebit
        totalSellerCredit
      }
    }
  }
`;

export const CREATE_ADJUSTMENT_MUTATION = gql`
  ${ADJUSTMENT_FIELDS}
  mutation CreateDcAdjustment($input: CreateDcAdjustmentInput!) {
    createDcAdjustment(input: $input) {
      adjustment {
        ...AdjustmentFields
      }
      mirrorAdjustment {
        ...AdjustmentFields
      }
    }
  }
`;

export const UPDATE_ADJUSTMENT_MUTATION = gql`
  ${ADJUSTMENT_FIELDS}
  mutation UpdateDcAdjustment($input: UpdateDcAdjustmentInput!) {
    updateDcAdjustment(input: $input) {
      adjustment {
        ...AdjustmentFields
      }
      mirrorAdjustment {
        ...AdjustmentFields
      }
    }
  }
`;

export const DELETE_ADJUSTMENT_MUTATION = gql`
  ${ADJUSTMENT_FIELDS}
  mutation DeleteDcAdjustment($input: DeleteDcAdjustmentInput!) {
    deleteDcAdjustment(input: $input) {
      adjustment {
        ...AdjustmentFields
      }
      mirrorAdjustment {
        ...AdjustmentFields
      }
    }
  }
`;

export const CLEAR_ADJUSTMENT_MUTATION = gql`
  ${ADJUSTMENT_FIELDS}
  mutation ClearDcAdjustment($input: ClearDcAdjustmentInput!) {
    clearDcAdjustment(input: $input) {
      adjustment {
        ...AdjustmentFields
      }
      mirrorAdjustment {
        ...AdjustmentFields
      }
    }
  }
`;
